export default "__VITE_ASSET__Da8KYE9E__"